/**
 * @fileoverview Settings Loader
 * @description Loads runtime configuration from settings endpoint
 * @module shared/settings-loader
 */

import { SecureLogger } from '@/shared/secure-logger';

/**
 * Load Settings
 * Auth/OAuth runtime config has been removed. Kept as a no-op so bootstrap
 * order in main.tsx stays stable.
 */
export async function loadSettings(): Promise<void> {
  SecureLogger.info('Settings loader skipped (auth disabled)');
}
